export const environment = {
  production: false,
  hmr: false,
  application: {
    name: 'Scholarship',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: 'https://api.destekmerkezi.site',
    clientId: 'Scholarship_App',
    dummyClientSecret: '1q2w3e*',
    scope: 'Scholarship',
    showDebugInformation: true,
    oidc: false,
    requireHttps: true,
  },
  apis: {
    default: {
      url: 'https://api.destekmerkezi.site',
    },
  },
  localization: {
    defaultResourceName: 'Scholarship',
  },
};
